module.exports = __webpack_public_path__ + "assets/img/fr-1adbf78d.png";